import {
    FETCH_POST_STARTED,
    FETCH_POST_ERROR,
    FETCH_POST_SUCCESS,
    Post,
    POST_POST,
    PUT_POST
  } from "./types";

export const fetchPostStarted = () => ({
    type : FETCH_POST_STARTED,
})
export const fetchPostError = (error:any) => ({
    type : FETCH_POST_ERROR,
    error
})
export const fetchPostSuccess = (id: number,post: Post) => ({
    type        : FETCH_POST_SUCCESS,
    id,
    post
})
export const postPostAction = (id: number) => ({
    type        : POST_POST,
    id
})
export const putPostAction = (id: number) => ({
    type        : PUT_POST,
    id
})